<template>
  <div class="header">
    <LoginBox :isShowFormBox="showLoginBox" @showPwReset="_showPwResetBox" @closeLogin="_closeLoginBox"
      @loginSuccess="_loginSuccess" />
    <PwResetBox :isShowPwResetBox="showPwResetBox" @closePwReset="_closePwResetBox"
      @swicthToLoginForm="_swicthToLoginForm" />
    <div class="nav_bar">
      <div class="logo">
        <a href="./home.html">
          <img src="../assets/2022/yingshiwang_w.png" alt="Logo">
        </a>
      </div>
      <div class="nav_box">
        <a href="./home.html" :class="{ active: curTab === 1 }" data-role="1">首页</a>
        <a href="./morescriptlist.html" :class="{ active: curTab === 2 }" data-role="2">剧本专区</a>
        <a href="./school.html" :class="{ active: curTab === 3 }" data-role="3">北门学院</a>
        <!-- <a href="./producer.html" :class="{active:curTab===4}" data-role="4" v-if="!loginSuc&&is_plan">项目专区</a> -->
        <!-- <a href="javascript:;" :class="{'go-upload':true,'active':changeCurTab,'red-border':redBorder}" @click="showUploadList" data-role="5">
            <span>作品上传</span>
            <ul class="upload-list" v-if="isShowUploadList" @mouseenter.self="clearHideUploadListInterval" @mouseleave.self="hideUploadList">
              <a href="./briefupload.html" target="_blank"><li>上传大纲</li></a>
              <a @click="goUploadScript" style="border-bottom:none"><li>上传剧本</li></a>
            </ul>
          </a> -->
        <!-- <a href="./vogue.html" :class="{active:curTab===3}" data-role="3">爆款测试入口</a> -->
        <!-- <a href="./writerlist.html" :class="{active:curTab===3}" data-role="3">编剧专区</a> -->
      </div>
      <!-- <div class="search-box">
          <input type="text" placeholder="请输入剧本名称" v-model="searchKeyWord" @keyup.enter="searchScript">
          <span class="search-btn" @click="searchScript"></span>
        </div> -->
      <div class="login_box">
        <p class="login_item" v-if="loginSuc">
          <a href="javascript:;" @click="toLoginPage" class="login-btn">登 录</a>
        </p>
        <div class="login_suc" v-if="!loginSuc">
          <a href="./usercenter.html" class="user-icon-link" style="vertical-align:top;"
            @mouseenter.stop="showLoginSucSel" @mouseleave.stop="hideLoginSucSel"><span class="user-icon-box"><img
                :src="userIcon" v-show="userIcon"></span></a>
          <span class="msg-sign" v-if="messageUnread != 0"></span>
          <div class="user_phone_num" style="vertical-align:top;" @mouseenter.stop="showLoginSucSel"
            @mouseleave.stop="hideLoginSucSel">
            <div class="login_suc_sel" v-show="!loginSucSelShow" ref="loginSucSel" @mouseenter="loginSucIn"
              @mouseleave="loginSucOut">
              <div class="user-brief-info">
                <div class="avatar">
                  <img :src="userIcon" v-show="userIcon">
                </div>
                <div class="info">
                  <div class="name-authen">
                    <div class="name">
                      <span class="name-box" :title="userName">{{ userName }}</span><img
                        v-if="users.white_info && users.white_info.is_vip" src="../assets/correcting-img/vip.png"
                        alt="">
                    </div>
                    <div class="authen">
                      <span class="done" v-if="userInfo.real_name_auth">已认证</span><span class="not"
                        v-if="!userInfo.real_name_auth">未认证</span>
                    </div>
                  </div>
                  <p class="exchange-info" v-if="userInfo.white_info && userInfo.white_info.date">
                    {{ userInfo.white_info && userInfo.white_info.type }}有效期至{{ userInfo.white_info &&
                        userInfo.white_info.date.substring(0, 10)
                    }}
                  </p>
                </div>
              </div>
              <div class="link-box">
                <div class="line-item"><img src="../assets/correcting-img/usercenter.png" alt="">
                  <div class="link-list"><a href="./usercenter.html">个人中心</a><span v-if="messageUnread != 0"></span>
                  </div>
                </div>
                <div class="line-item"><img src="../assets/correcting-img/security.png" alt="">
                  <div class="link-list"><a href="./safecenter.html">安全中心</a></div>
                </div>
                <div class="line-item"><img src="../assets/correcting-img/logout.png" alt="">
                  <div class="link-list" @click="logout" style="cursor:pointer"><a>退出</a></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import Axios from '@/api/Axios'
import axios from 'axios'
import LoginBox from '@/components/LoginBox'
import PwResetBox from '@/components/PwResetBox'
import { mapActions, mapGetters } from 'vuex'
import { GetCookie, DelCookie, SetCookie } from '@/api/cookie'
import { getParams } from '@/api/getUrlParams'
// import { message } from '@/api/resetMsg';
export default {
  name: 'HeaderNav',
  props: ['curTab', 'changeAvatar'],
  store,
  data() {
    return {
      userInfo: '',                  //储存用户信息
      userName: '',                  //储存用户名
      loginSuc: true,                //登陆成功后一场登陆注册按钮显示用户头像和用户名div
      loginSucSelShow: true,         //鼠标移入用户名后显示个人中心安全中心下拉框
      getTokenCookie: '',            //储存缓存里的TOKEN判断是否已登陆
      userIcon: '',                  //用户头像图片
      timer: '',                     //个人中心安全中心下拉菜单滑鼠事件
      is_plan: '',                   //判断是否有进入项目专区权限
      showLoginBox: '',              //控制登录弹窗显示隐藏
      showPwResetBox: '',            //作为中间变量储存登陆弹窗点击忘记密码传来的值再给忘记密码组件传值
      changeCurTab: false,           //作品上传点击active状态
      isShowUploadList: false,       //点击作品上传显示上传入口列表
      hideTimer: '',                 //作品上传入口显示时间
      redBorder: false,              //作品上传选项下边框样式
      pwResetReload: '',              //修改密码页面重新加载
      searchKeyWord: ''
    }
  },
  created() {
    //根据URL中是否有KEY值判断用户是否使用三方登陆
    //如果有KEY的话则是通过三方登陆登录 用KEY值请求接口获取用户信息
    if (getParams('key')) {
      Axios.get('thirdlogin/' + getParams('key')).then(
        response => {
          if (response.data.code == 201) {
            //如果通过三方登陆URL中有KEY则在取回数据时为导航头像和用户名赋值
            this.userIcon = response.data.data.icon
            this.userName = response.data.data.name
            this.loginSuc = false
            SetCookie('token', response.data.data.token)
            SetCookie('phone', response.data.data.phone)
            SetCookie('real_auth', response.data.data.real_name_auth)
            SetCookie('v', response.data.data.white_info.is_vip)
            this.getTokenCookie = GetCookie('token')
            // localStorage.removeItem('reloadLoginPage')
            // localStorage.setItem('closeLoginPage',Math.random().toString(36).substr(5))
            let url = window.location.href
            let valiable = url.split("?")[0]
            window.history.pushState({}, 0, valiable)
          }
        },
        error => {
          console.log(error)
          this.$message.error({
            message: '获取个人信息失败 请刷新重试',
            type: 'error',
            center: true,
            offset: 100,
            duration: 900
          });
        }
      )
    }
    //刷新页面后从缓存读取用户名和用户头像和未读消息
    if (GetCookie('token')) {
      this.readUnreadMessage()
      this.readUsers()
    }
    GetCookie('token') ? this.loginSuc = false : this.loginSuc = true
  },
  mounted() {
    if (GetCookie('PWRT')) {
      this.showLoginBox = true
      DelCookie('PWRT')
    }
    if (GetCookie('PRT')) {
      this.showLoginBox = true
      DelCookie('PRT')
    }
  },
  computed: {
    ...mapGetters(['users', 'messageUnread'])
  },
  watch: {
    'getTokenCookie': function (val) {
      val ? this.loginSuc = false : this.loginSuc = true
    },
    'users': function (val) {
      this.userInfo = val
      this.userName = val.name
      this.is_plan = val.is_plan
      this.userIcon = val.icon
    },
    'isShowUploadList': function (val) {
      if (val) {
        this.hideTimer = setInterval(() => {
          this.isShowUploadList = false
          this.changeCurTab = false
          this.redBorder = false
        }, 2000)
      }
    },
    'changeAvatar': function (val) {
      this.userIcon = val
    },
  },
  methods: {
    ...mapActions(['readUsers', 'readUnreadMessage']),
    //鼠标移入作品上传列表清除定时器移出时再隐藏
    clearHideUploadListInterval() {
      clearInterval(this.hideTimer)
    },
    //鼠标移出作品上传列表时隐藏作品上传列表
    hideUploadList() {
      this.isShowUploadList = false
      this.changeCurTab = false
      this.redBorder = false
    },
    //点击显示作品上传入口
    showUploadList() {
      clearInterval(this.hideTimer)
      this.isShowUploadList = !this.isShowUploadList
      this.changeCurTab = !this.changeCurTab
      this.redBorder = !this.redBorder
    },
    //点击登录弹出登录对话框
    toLoginPage() {
      this.showLoginBox = true
    },
    //关闭登录对话框
    _closeLoginBox(val) {
      this.showLoginBox = val
    },
    //监听登陆对话框中的点击忘记密码事件 切换到忘记密码弹窗
    _showPwResetBox(val) {
      this.showPwResetBox = val
    },
    //关闭忘记密码表单弹窗
    _closePwResetBox(val) {
      this.showPwResetBox = val
    },
    //收到Login组件登陆成功状态后改变上导航登陆状态
    _loginSuccess(val) {
      if (val) {
        setTimeout(() => {
          window.location.reload()
        }, 400)
      }
    },
    //搜索框搜索剧本方法
    searchScript() {
      if (this.searchKeyWord === '') {
        this.$message.error({
          message: '请输入剧本名称',
          type: 'error',
          center: true,
          offset: 100,
          duration: 900
        })
      } else {
        let data = new Date()
        this.now = data.getFullYear() + '-'
        this.now = this.now + (data.getMonth() + 1) + '-'
        this.now = this.now + (data.getDate()) + ' '
        this.now = this.now + (data.getHours()) + ':'
        this.now = this.now + (data.getMinutes()) + ':'
        this.now = this.now + (data.getSeconds())
        Axios.get('/article/list', { 'search': this.searchKeyWord, 'limitdate': this.now }).then(
          response => {
            if (response.data.code == 200 && response.data.status == 'success') {
              if (response.data.data.length) {
                window.open('/morescriptlist.html?kw=' + this.searchKeyWord)
              } else {
                this.$message.warning({
                  message: '未搜到相关剧本',
                  type: 'warning',
                  center: true,
                  offset: 100,
                  duration: 900
                })
              }
            }
          },
          error => {
            console.log(error)
            this.$message.error({
              message: '出错了  请稍后重试',
              type: 'error',
              center: true,
              offset: 100,
              duration: 900
            })
          }
        )
      }
    },
    //监听忘记密码表单弹窗中点击返回登陆按钮事件 切换回登陆表单
    _swicthToLoginForm() {
      this.showLoginBox = true
      this.showPwResetBox = false
    },
    showLoginSucSel() {
      clearInterval(this.timer)
      this.loginSucSelShow = false;
    },
    hideLoginSucSel() {
      this.timer = setTimeout(() => {
        this.loginSucSelShow = true;
      }, 600)
    },
    loginSucIn() {
      clearInterval(this.timer)
      this.loginSucSelShow = false;
    },
    loginSucOut() {
      this.loginSucSelShow = true;
    },
    goUploadScript() {
      if (!GetCookie('token')) {
        this.$message.error({
          message: '未登录 不能进行此操作',
          type: 'error',
          center: true,
          offset: 100,
          duration: 900
        });
        return false
      } else {
        window.open("/uploadscript.html", "_blank")
      }
    },
    logout() {
      axios({
        method: 'post',
        url: 'https://admin.beimen.com/api/v1/logout',
        headers: {
          'Authorization': GetCookie('token')
        }
      }).then(
        response => {
          if (response.data.code == 200 && response.data.status == "success") {
            this.loginSuc = true
            DelCookie("token")
            DelCookie("real_auth")
            DelCookie("v")
            DelCookie("name")
            DelCookie("icon")
            setTimeout(function () { location.href = '/home.html' }, 300)
          }
        },
        error => {
          console.log(error)
          this.$message.error({
            message: '网络错误   请稍后再试',
            type: 'error',
            center: true,
            offset: 100,
            duration: 900
          });
        }
      );
    }
  },
  components: {
    LoginBox,
    PwResetBox
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.active {
  color: #222222 !important;
  font-weight: bold !important;
}

.header {
  width: 100%;
  min-width: 1200px;
  height: 80px;
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
}

.login_suc_sel {
  width: 350px;
  height: 270px;
  position: absolute;
  z-index: 999999;
  text-align: center;
  background: #fff;
  top: 64px;
  left: -300px;
  border-radius: 0px 0px 2px 2px;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);

  .user-brief-info {
    width: 350px;
    height: 100px;
    padding: 20px;
    background: #f7f7f7;

    .avatar {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      float: left;
      margin-right: 15px;

      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }

    .info {
      width: 245px;
      float: left;

      .name-authen {
        font-size: 18px;
        color: #222;
        font-weight: bold;
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;

        .name {
          .name-box {
            width: 134px;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          span,
          img {
            float: left;
          }

          img {
            width: 32px;
            height: 28px;
            transform: translateY(7px);
          }
        }

        .authen {
          span {
            width: 55px;
            height: 22px;
            line-height: 22px;
            text-align: center;
            font-size: 14px;
            border-radius: 20px;
            padding: 2px 10px;
          }

          .done {
            background: #BF0000;
            color: #fff;
          }

          .not {
            color: #999;
            background: #E6E6E6;
          }
        }
      }

      .exchange-info {
        font-size: 14px;
        color: #999;
        text-align: left;
        letter-spacing: 2px;
      }
    }
  }

  .link-box {
    height: 170px;
    width: 350px;
    padding-left: 90px;
  }

  .line-item {
    display: -webkit-flex;
    display: flex;
    align-items: center;
    width: 100%;

    img {
      width: 14px;
      height: 18px;
      margin-right: 10px;

    }
  }

  .link-list {
    text-align: left;
    width: 230px;
    border-bottom: 1px solid #e6e6e6;
    padding: 7px 0;
    position: relative;

    a {
      text-decoration: none;
      font-size: 18px;
      text-align: center;
      color: #222;
      letter-spacing: 2px;
    }

    span {
      display: inline-block;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #BF0000;
      position: absolute;
      left: 80px;
      top: 12px;
    }
  }

  .line-item:last-child .link-list {
    border-bottom: none;
  }

  .line-item:hover {
    a {
      color: #BF0000;
    }
  }
}

.nav_bar {
  width: 1200px;
  height: 80px;
  padding: 10px 20px;
  margin: 0 auto;
  position: relative;

  .logo,
  .nav_box,
  .login_box {
    position: absolute;
  }
}

.logo {
  // width: 156px;
  width: 297px;
  height: 47px;
  left: 0;
  top: 50%;
  transform: translateY(-50%);

  img {
    width: 100%;
    height: 100%;
  }
}

.nav_box {
  height: 60px;
  padding: 0 10px;
  line-height: 60px;
  // left: 180px;
  left: 307px;

  a {
    display: inline-block;
    padding: 0 20px;
    text-decoration: none;
    color: #7E7E7E;
    font-size: 18px;
    font-weight: 400;
  }

  a:hover {
    opacity: 0.7;
  }

  .go-upload {
    position: relative;

    .upload-list {
      width: 120px;
      height: 124px;
      background: #fff;
      position: absolute;
      top: 74px;
      left: -14px;
      padding: 0 10px;
      text-align: center;
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);

      a:hover {
        opacity: 1 !important;
      }

      a {
        border-bottom: 1px solid #e6e6e6;
      }

      li {
        text-align: center;
      }

      li:hover {
        color: #BF0000;
      }
    }
  }

  .red-border::after {
    content: "";
    width: 34px;
    height: 4px;
    background: #bf0000;
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
  }

  .go-upload:hover {
    opacity: 1 !important;

    span {
      opacity: 0.7;
    }
  }
}

.search-box {
  position: absolute;
  left: 740px;
  width: 340px;
  height: 40px;
  top: 50%;
  transform: translateY(-20px);

  input {
    width: 300px;
    padding: 0 20px;
    background: #F2F2F2;
    border-radius: 30px;
    border: none;
    outline: none;
    height: 40px;
    color: #7E7E7E;
  }

  input::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #ccc;
  }

  input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #ccc;
  }

  input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #ccc;
  }

  input:-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: #ccc;
  }

  .search-btn {
    display: inline-block;
    width: 20px;
    height: 20px;
    background: url('../assets/correcting-img/search-icon.png') no-repeat;
    position: absolute;
    top: 50%;
    right: 18px;
    transform: translateY(-10px);
    cursor: pointer;
  }
}

.login_box {
  height: 40px;
  line-height: 40px;
  color: #fff;
  right: 0px;
  width: 90px;
  text-align: right;
  top: 50%;
  transform: translateY(-20px);

  .login_item {
    width: 90px;
    display: inline-block;

    .login-btn {
      display: inline-block;
      height: 40px;
      line-height: 40px;
      border-radius: 30px;
      padding: 0 20px;
      width: 50px;
      background: #282828;
      text-decoration: none;
      color: #FEFEFE;
      font-size: 14px;
      font-weight: 500;
      text-align: center;
      cursor: pointer;
    }

    .login-btn:hover {
      background: rgba(0, 0, 0, .7)
    }
  }

  .login_suc {
    width: 40px;
    height: 40px;
    line-height: 40px;
    position: absolute;
    z-index: 9999;

    .user-icon-link {
      display: inline-block;
      width: 40px;
      height: 40px;
    }

    .msg-sign {
      display: inline-block;
      position: absolute;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #bf0000;
      left: 34px;
      top: 0;
    }

    .user-icon-box {
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 50%;

      img {
        height: 40px;
        width: 40px;
        border-radius: 50%;
      }
    }
  }
}

.header-register {
  display: inline-block;
  width: 84px;
  height: 34px;
  text-align: center;
  line-height: 34px;
  border: 1px solid #FAFAFA;
  background: #535353;
  border-radius: 30px;
  color: #FEFEFE;
}
</style>
